<template>
    <div class="dropdown">
        <div class="toggle" @click="opened=!opened">
            {{selected.label}}
            <icon name="angle-down"/>
        </div>
        <ul class="dropdown-menu" :style="{display:opened?'block':'none'}">
            <div class='item' v-for="item in options"  @click="click(item)">{{item.label}}</div>
        </ul>
    </div>
</template>

<script>

    export default {
        name: "dropdown",
        computed: {
            selected(){
                return this.options.find((option)=>{
                    return option.value === this.value;
                })
            }
        },
        data(){
            return {
                opened:false
            }
        },
        methods: {
            click(item){
                this.$emit('input', item.value);
            }
        },
        props:{
            value: String,
            options:{
                type: Array
            }
        }
    }
</script>

<style scoped>
.dropdown{
    display: inline-block;
    vertical-align: top;
}
.toggle img{
    vertical-align: middle;
}

.toggle{
    color:white;
    padding:8px 4px;
    vertical-align: top;
    cursor: pointer;
    overflow:hidden;
}
.toggle:hover{
    background:rgba(255,255,255,0.2);
}

    .dropdown-menu {
        background: white;
        min-width: 0px;
        padding:0;
        position: absolute;
    }

    .dropdown-menu .item:hover {
        background: #cbcfcd;
    }
    .dropdown-menu .item {
        display: block;
        padding: 3px 3px;
        cursor: pointer;
        line-height: 1;

    }

</style>